document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav
  var toggle = document.querySelector('.mobile-toggle');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('open');
    });
  }

  // FAQ accordion
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q');
    if (!q) return;
    q.addEventListener('click', function () {
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function (i) {
        if (i !== item) i.classList.remove('open');
      });
      item.classList.toggle('open', !wasOpen);
    });
  });

  // Pricing tabs (Cash / Options / Futures)
  var tabs = document.querySelectorAll('.pricing-tab');
  var groups = document.querySelectorAll('.pricing-group');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.getAttribute('data-target');
      tabs.forEach(function (t) { t.classList.remove('active'); });
      groups.forEach(function (g) { g.classList.remove('active'); });
      tab.classList.add('active');
      var el = document.getElementById(target);
      if (el) el.classList.add('active');
    });
  });

  // Add-to-cart forms on homepage plan cards — simple, no-JS-required fallback works too
  // (forms post directly to /cart/add with redirect built into the form action)

  // Contact / lead form — Shopify's native contact form already handles submission + reload;
  // this just improves inline feedback if a success/error param is present.
  var params = new URLSearchParams(window.location.search);
  if (params.get('contact_posted') === 'true') {
    var successEl = document.querySelector('.form-success');
    if (successEl) successEl.style.display = 'block';
  }
});
